"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOGIN_MFA_DEFAULT_TEXTS = void 0;
exports.LOGIN_MFA_DEFAULT_TEXTS = {
    placeholderMFACode: 'Code',
    actionLogIn: 'Log in',
    errorRequired: 'The field is required',
    errorMaxLength: 'The maximum length is {{length}}',
    warningMFA: 'Multi-factor authentication is enabled for this account. To log in, enter the verification code sent to your trusted device.'
};
//# sourceMappingURL=constants.js.map